import { Colors } from "../../../consts/Colors";
import ButtonRounded from "../../global/buttons/ButtonRounded";
import ButtonQ1 from "../ordi/ButtonQ1";
import QuestionPanel from "./QuestionPanel";
export default class QuestionPanel_1 extends QuestionPanel {
    constructor(scene, x, y, {config, totQuestion}) {
        super(scene, x, y, {
            numquestion: 1,
            totQuestion,
            question: config.question,
            soustitre: config.soustitre,
            textIndice: config.indice
        });


        // Ajout input
        let Y  = this.aideButton.y + this.aideButton.height/2 + 52

        // Ajout ligne
        let line = this.scene.add.rectangle(80 + 131, Y - 20, 1, 410, Colors.Elmt.DarkGrey).setOrigin(0)
        this.add(line)

        this.inputs = [];
        config.reponses.forEach( (reponse, index) => {
            let input = new ButtonQ1(this.scene, 80 + 62, Y, reponse.text, reponse.isTrue)
            this.inputs.push(input);
            this.add(input);
            Y+= input.height + 26
        })

        line.height = Y - line.y - 26

        // Ajout bouton valider
        this.validateButton = new ButtonRounded(this.scene, this.width /2, Y + 26, {
            text: "Valider vos réponses",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.White,
        })
        this.add(this.validateButton)
        this.validateButton.y+= this.validateButton.height/2
        this.validateButton.setClickFunction( () => {
            this.validateButton.disableInteractive()
            // On bloque tous les éléments du panneau
            this.setLocked()

            // On vérifie la réponse
            if(this.isTrue() || this.tentative >= this.maxTentative){
                this.scene.showReponsePopUp({
                    text: config.correction,
                    isTrue: this.isTrue(),
                    endFunc: () => {
                        this.scene.closePanelQuestion((scene) => {scene.addQuestionPanel2();});
                        this.scene.closeReponsePopUp();
                    }
                });
            }else{
                this.scene.cameras.main.shake(200, 0.01);
                this.tentative++;
                this.setUnlocked();
            }
        })
    }

    setLocked(){
        super.setLocked();
        this.inputs.forEach(input => input.setLocked());
    }

    setUnlocked(){
        super.setUnlocked();
        this.inputs.forEach(input => input.setUnlocked());
        this.validateButton.setInteractive();
    }

    isTrue(){
        return this.inputs.every(input => input.isTrue());
    }
}